import { Link } from 'gatsby';
import PageTemplate from '../layouts/pageTemplate';
import Button from '@material-ui/core/Button';
import HomeIcon from '@material-ui/icons/Home';

const ErrorPage = () => (
  <PageTemplate title="404エラー" center='center'>
          <h1>不好意思 您找的网页不存在</h1>
      <h3>This page does not exist or is no longer reachable.</h3>
      <h3>
        回头再查一下
      </h3>
      <Button  variant="contained" color="primary" style={{ backgroundColor:"#3f51b5"}}  href="/" startIcon={<HomeIcon />}>ホームへ</Button>
  </PageTemplate>
);

export default ErrorPage;
